import { Text, Heading, TextLinkButton } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import { Link } from 'src/components/Router/Link';

interface InlineNudgeProps {
  fieldToFocus: string;
  nudgeText: string;
  displayText: string;
  data: Record<string, string>;
  type: 'Heading' | 'Text';
  icon?: ComponentProps<typeof Text>['icon'];
}

export const InlineNudge = ({
  displayText,
  nudgeText,
  fieldToFocus: focusOn,
  data,
  type,
  icon,
}: InlineNudgeProps) => {
  const displayTextContent = (
    <span data-hj-masked data-automation={data.automation}>
      {displayText ? (
        displayText
      ) : (
        <Link
          to="personal-details"
          mode="EDIT"
          params={{ focusOn }}
          component={TextLinkButton}
        >
          {nudgeText}
        </Link>
      )}
    </span>
  );

  if (type === 'Heading') {
    return (
      <Heading level="1" component="p" icon={icon}>
        {displayTextContent}
      </Heading>
    );
  }

  return (
    <Text maxLines={1} icon={icon}>
      {displayTextContent}
    </Text>
  );
};
